import React, { Component } from 'react';
import FilterBasic from '../../basicElement/FilterBasic';
import API_URL from '../../../common/url';

class Filter extends Component {
    render() {
        const { ...rest } = this.props;
        const filters = [{
            name: '时间',
            key: 'begin',
            type: 'monthPicker',
        }, {
            name: '至',
            key: 'end',
            type: 'monthPicker',
        }, {
            name: '中心编号/中心名称',
            key: 'investigationSite',
            type: 'searchRetrieve',
            typeProperty: {
                keyword: 'searchKey',
                style: {width: 160},
                placeholder: '输入中心编号/名称检索',
                params: {limit: 20},
                url: API_URL.site.list,
                config: { id: 'investigationSiteId', name: 'investigationSiteName', code: 'investigationSiteCode', type: 'site', show: 'site' },
            }
        }, {
            name: 'CRC',
            key: 'user',
            type: 'searchRetrieve',
            typeProperty: {
                keyword: 'keyword',
                style: {width: 140},
                placeholder: '输入姓名/工号检索',
                params: {limit: 20},
                url: API_URL.team.userlist,
                config: { id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' },
            }
        }, {
            name: '人员状态',
            key: 'status',
            type: 'select',
            typeProperty: {
                list: [
                    { value: 'ACTIVE', label: '现任' },
                    { value: 'INACTIVE', label: '前任' },
                    { value: 'LEFT', label: '离职' },
                ]
            }
        }];
        return (
            <FilterBasic filters={filters} {...rest} />
        )
    }
}

export default Filter;


// WEBPACK FOOTER //
// ./src/components/member/staffEfficiency/Filter.js